import {AditivoService} from './../../services/aditivo.service';
import {Aditivo} from './../../model/Aditivo';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PacService} from 'src/app/services/pac.service';
import {DocumentoPac} from 'src/app/model/DocumentoPac';
import {Observable, Subscription} from 'rxjs';
import { BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import {ResultadoAprovacaoAditivo} from 'src/app/model/ResultadoAprovacaoAditivo';
import {Fases} from '../../common/constants/Fases';
import {Aviso} from 'src/app/model/Aviso';
import {ResultadoValidacaoAditivo} from 'src/app/model/ResultadoValidacaoAditivo';
import { AppRole } from 'src/app/common/constants/app-role.constant';
import { ResultadoConsultaErros } from 'src/app/model/ResultadoConsultaErros';
import { ErroService } from 'src/app/services/erro.service';

@Component({
  selector: 'analisa-aditivo',
  templateUrl: './analisa-aditivo.component.html',
  styleUrls: ['./analisa-aditivo.component.scss'],
  standalone: false
})
export class AnalisaAditivoComponent implements OnInit, OnDestroy {

  aditivo: Aditivo;
  pacOriginal: DocumentoPac;
  usuarioSubscription: Subscription;
  usuario: Usuario;
  comentario: string;
  motivoDevolucao: string;
  avisosFluxoAprovacao: Aviso[];
  resultadoValidacaoAditivo: ResultadoValidacaoAditivo;
  resultadoConsultaErros: ResultadoConsultaErros;
  exibeTodosAvisosFluxoAprovacao: boolean;
  podeAditar: boolean;
  operacaoN03: string;

  constructor(
    private service: AditivoService,
    private pacService: PacService,
    private aditivoService: AditivoService,
    private alertService: BnAlertsService,
    private errosservice: ErroService,
    private route: ActivatedRoute,
    private usuarioService: BnUsuarioService,
  ) {
  }

  ngOnInit(): void {
    this.usuarioSubscription = this.usuarioService.usuario$.subscribe(
      (usuario: Usuario) => {
        this.usuario = usuario;
        if (this.usuarioEhBndes()) {
          this.route.paramMap.subscribe(
            m => {
              const id = m.get('id');
              this.atualizaAditivo(id);
            }
          );
        } else {
          this.alertService.alertaErro('Erro', 'Usuário não tem acesso a esta página.');
        }
      });

  }

  private refreshAditivo() {
    this.atualizaAditivo(this.aditivo.id + '');
  }

  private atualizaAditivo(idAditivo: string): void {
    this.resultadoValidacaoAditivo = null;
    this.service.obterAditivo(idAditivo).subscribe(
      a => {
        this.aditivo = a;
        this.motivoDevolucao = this.aditivo.motivoDevolucao;
        if (this.pacOriginal == null) {
          this.atualizaPacOriginal(a.idPacAditada);
        }
        this.verificaPacComOperacaoAtiva(a.idPacAditada);
        this.validarAditivo(idAditivo);
        this.obtemErros(a.idPacNova);
      },
      error => {
        console.log('Houve erro ao obter o aditivo ' + idAditivo + '. ' + error.message);
        console.debug(error);
        this.alertService.alertaErro('Erro', 'Houve erro ao obter o aditivo ' + idAditivo + '.');
      }
    );

    this.service.obterAvisosFluxoAprovacao(idAditivo).subscribe(
      a => {
        this.avisosFluxoAprovacao = a.list;
        this.exibeTodosAvisosFluxoAprovacao = false;
      },
      error => {
        console.log('Houve erro ao obter os avisos do fluxo de aprovação do aditivo ' + idAditivo + '. ' + error.message);
        console.debug(error);
        this.alertService.alertaErro('Erro', 'Houve erro ao obter os avisos do fluxo de aprovação do aditivo ' + idAditivo + '.');
      }
    );
  }

  private obtemErros(idAditivo: number): void {
    this.resultadoConsultaErros = null;
    this.errosservice.ultimosErrosDoDocumento(idAditivo).subscribe(
      a => {
        this.resultadoConsultaErros = a;
      },
      error => {
        console.log('Houve erro ao obter os erros do aditivo ' + idAditivo + '. ' + error.message);
        console.debug(error);
        this.alertService.alertaErro('Erro', 'Houve erro ao obter os erros do aditivo ' + idAditivo + '.');
      }
    );
  }

  private verificaPacComOperacaoAtiva(id: number) {
    this.podeAditar = null;
    this.pacService.pacComOperacaoAtiva(id + '').subscribe(
      r => {
        console.log('PAC ' + id + ' relacionada a uma operação aditável? ' + r.podeAditar);
        this.podeAditar = r.podeAditar;
        this.operacaoN03 = r.operacaoN03;
        if (this.ehFaseEUsuarioAprovador() && !this.podeAditar) {
          this.alertService.alertaErro('Erro', 'A PAC ' + id + ' alterada por este aditivo não está ativa e não pode ser aditada.');
        }
      },
      error => {
        console.log('Houve erro ao verificar a situação da operação relacionada à PAC aditada ' + id + '. ');
        console.debug(error);
        this.alertService.alertaErro('Erro', 'Houve erro ao obter situação da PAC aditada: ' + id + '.');
      }
    );
  }

 podeAprovarAditivo() {
    return this.podeAditar !== null && this.podeAditar;
  }

  contemErrosValidacao() {
    return this.resultadoValidacaoAditivo?.erros?.length > 0;
  }

  private validarAditivo(idAditivo: string): void {
    this.executaValidacaoEAprovacao(idAditivo, false);
  }

  private validarAditivoEAprovar(idAditivo: string): void {
    this.executaValidacaoEAprovacao(idAditivo, true);
  }

  private executaValidacaoEAprovacao(idAditivo: string, aprovaAditivoAposValidacao: boolean): void {
    if (!this.ehFaseAnaliseAditivoEUsuarioEhAnalista()) {
      console.log('Não precisa validar!');
      return;
    }
    this.service.validarAditivo(idAditivo).subscribe(
      r => {
        this.resultadoValidacaoAditivo = r;
        console.log('Validado o aditivo ' + idAditivo + '.');
        console.debug(r);
        if (aprovaAditivoAposValidacao) {
          this.analistaAprovarAditivo();
        }
      },
      error => {
        this.resultadoValidacaoAditivo = null;
        console.log('Houve erro ao validar o aditivo ' + idAditivo + '.', error);
        if (aprovaAditivoAposValidacao) {
          this.alertService.alertaErro('Erro', 'Houve erro ao validar o aditivo ' + idAditivo + '.');
        }
      }
    );
  }


  private atualizaPacOriginal(idPacAditada: number): void {
    this.pacService.obterPac(idPacAditada + '').subscribe(pa => {
      this.pacOriginal = pa;
    });
  }

  ngOnDestroy(): void {
    if (this.usuarioSubscription) {
      this.usuarioSubscription.unsubscribe();
    }
  }

  ehFaseEUsuarioAprovador() {
    return this.ehFaseAnaliseAditivoEUsuarioEhAnalista() ||
      this.ehFaseAprovacaoGerenteEUsuarioEhGerente() ||
      this.ehFaseAprovacaoChefeEUsuarioEhChefe();
  }

  ehFaseAnaliseAditivoEUsuarioEhAnalista() {
    return (this.aditivo?.situacaoFase == Fases.FASE_ANALISE_ANALISTA) && this.usuario.possuiPermissao(AppRole.BNDES_ANALISTA);
  }

  ehFaseAprovacaoGerenteEUsuarioEhGerente() {
    return (this.aditivo?.situacaoFase == Fases.FASE_ANALISE_GERENTE) && this.usuario.possuiPermissao(AppRole.BNDES_GERENTE);
  }

  ehFaseAprovacaoChefeEUsuarioEhChefe() {
    return (this.aditivo?.situacaoFase == Fases.FASE_ANALISE_CHEFE) && this.usuario.possuiPermissao(AppRole.BNDES_CHEFE);
  }

  private validaFaseAnaliseAditivoEUsuarioEhAnalista() {
    return this.validaSituacaoUsuario(Fases.FASE_ANALISE_ANALISTA, AppRole.BNDES_ANALISTA);
  }

  private validaFaseAprovacaoGerenteEUsuarioEhGerente() {
    return this.validaSituacaoUsuario(Fases.FASE_ANALISE_GERENTE, AppRole.BNDES_GERENTE);
  }

  private validaFaseAprovacaoChefeEUsuarioEhChefe() {
    return this.validaSituacaoUsuario(Fases.FASE_ANALISE_CHEFE, AppRole.BNDES_CHEFE);
  }

  private validaSituacaoUsuario(fase: string, permissao: string): boolean {
    if (this.aditivo?.situacaoFase !== fase) {
      this.alertService.alertaErro('Erro', 'Este aditivo deveria estar na fase \'' + fase + '\' mas está na: \'' + this.aditivo?.situacaoFase + '\'.');
      return false;
    }
    if (!this.usuario.possuiPermissao(permissao)) {
      this.alertService.alertaErro('Erro', 'O usuário atual não tem permissão de \'' + permissao + '\'.');
      return false;
    }
    return true;
  }

  analistaAprovarAditivo() {
    if (!this.validaFaseAnaliseAditivoEUsuarioEhAnalista()) {
      return;
    }

    if (this.resultadoValidacaoAditivo === null) {
      this.validarAditivoEAprovar(this.aditivo.id + '');
      return;
    }

    if (this.resultadoValidacaoAditivo.erros.length > 0) {
      this.alertService.alertaErro('Erro', 'Existem erros de validação neste aditivo. Favor revisá-los.');
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.analistaAprovarAditivo(this.aditivo.id, this.comentario),
      'Aditivo aprovado com sucesso.',
      'Houve erros ao aprovar o aditivo.'
    );
  }

  analistaAprovarAditivoComRessalvas() {
    if (!this.validaFaseAnaliseAditivoEUsuarioEhAnalista()) {
      return;
    }

    if ((this.resultadoValidacaoAditivo === null) || (this.resultadoValidacaoAditivo.erros === null)
        || (this.resultadoValidacaoAditivo.erros.length === 0)) {
      this.validarAditivo(this.aditivo.id + '');
      this.alertService.alertaErro('Erro', 'Não foi possível localizar os erros de validação do aditivo. Tente novamente.');
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.analistaAprovarAditivoComRessalvas(this.aditivo.id, this.comentario),
      'Sucesso ao aprovar o Aditivo aprovado com ressalvas.',
      'Houve erros ao aprovar o aditivo.'
    );
  }

  analistaRejeitarAditivo() {
    if (!this.validaFaseAnaliseAditivoEUsuarioEhAnalista()) {
      return;
    }

    if (!this.motivoDevolucao || this.motivoDevolucao.trim() === '') {
      this.alertService.alertaErro('Erro', 'É necessário informar o Motivo da Devolução');
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.analistaRejeitarAditivo(this.aditivo.id, this.comentario, this.motivoDevolucao),
      'Aditivo rejeitado com sucesso.',
      'Houve erros ao rejeitar o aditivo.'
    );
  }

  gerenteAprovarAditivo() {
    if (!this.validaFaseAprovacaoGerenteEUsuarioEhGerente()) {
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.gerenteAprovarAditivo(this.aditivo.id, this.comentario),
      'Aditivo aprovado com sucesso.',
      'Houve erros ao aprovar o aditivo.'
    );
  }

  gerenteRejeitarAditivo() {
    if (!this.validaFaseAprovacaoGerenteEUsuarioEhGerente()) {
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.gerenteRejeitarAditivo(this.aditivo.id, this.comentario),
      'Aditivo rejeitado com sucesso.',
      'Houve erros ao rejeitar o aditivo.'
    );
  }

  gerenteReencaminharAditivo() {
    if (!this.validaFaseAprovacaoGerenteEUsuarioEhGerente()) {
      return;
    }

    if (!this.comentario || this.comentario.trim() === '') {
      this.alertService.alertaErro('Erro', 'É necessário informar um Comentário sobre Análise explicando o reencaminhamento.');
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.gerenteReencaminharAditivo(this.aditivo.id, this.comentario),
      'Aditivo reencaminhado para Analista com sucesso.',
      'Houve erros ao reencaminhar o aditivo para Analista.'
    );
  }

  chefeAprovarAditivo() {
    if (!this.validaFaseAprovacaoChefeEUsuarioEhChefe()) {
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.chefeAprovarAditivo(this.aditivo.id, this.comentario),
      'Aditivo aprovado com sucesso.',
      'Houve erros ao aprovar o aditivo.'
    );
  }

  chefeReencaminharAditivo() {
    if (!this.validaFaseAprovacaoChefeEUsuarioEhChefe()) {
      return;
    }

    if (!this.comentario || this.comentario.trim() === '') {
      this.alertService.alertaErro('Erro', 'É necessário informar um Comentário sobre Análise explicando o reencaminhamento.');
      return;
    }

    this.trataObservableServicosAprovacao(this.aditivoService.chefeReencaminharAditivo(this.aditivo.id, this.comentario),
      'Aditivo reencaminhado para Analista com sucesso.',
      'Houve erros ao reencaminhar o aditivo para Analista.'
    );
  }

  private trataObservableServicosAprovacao(obs: Observable<ResultadoAprovacaoAditivo>, msgSucesso: string, msgErro: string): void {

    obs.subscribe({
      next: resp => {
        if (!resp.erro || resp.erro.length == 0) {
          this.alertService.alertaSucesso('', msgSucesso);
          this.refreshAditivo();
        } else {
          this.alertService.alertaErro('Erro', msgErro + ' Erro: ' + resp.erro);
        }
      },
      error: error => {
        this.alertService.alertaErro('Erro', msgErro + ' Erro: ' + error.message);
        console.error(error);
      }
    });
  }

  usuarioEhBndes(): boolean {
    return this.usuario.possuiPermissao(AppRole.BNDES_ANALISTA) ||
           this.usuario.possuiPermissao(AppRole.BNDES_GERENTE) ||
           this.usuario.possuiPermissao(AppRole.BNDES_CHEFE);
  }

  onAlternarVisualizacaoAvisos(): void {
    this.exibeTodosAvisosFluxoAprovacao = !this.exibeTodosAvisosFluxoAprovacao;
  }
}
